<div class="container" @fadeIn [class.transparent]="hasTransparency">
	<div class="spinner" *ngIf="!isLoadingFailed && !isHorizontalLoader" [class.small]="isInline"></div>
	<div class="horizontal-loader" *ngIf="isHorizontalLoader"></div>
	<mat-icon *ngIf="isLoadingFailed">{{ matIconFailed || 'close' }}</mat-icon>
	<h3 *ngIf="loaderMessage">{{ loaderMessage }}</h3>
</div>